module.exports = __webpack_public_path__ + "img/interact_feature_7.d123de75.png";